import moment from "moment";
import "moment/locale/it";

export default function(value, format){
    if(value == null){
        return 0;
    }
    if(format == null){
        format = "DD/MM/YYYY";
    }

    let d = moment(value, [format], true);
    if(!d.isValid()) return 0;
    return d.toDate().getTime();
}
